import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import publishCourseImg from './publish.svg';
import { Button, NamedLink } from '../../../components';

import css from './SectionFreeCreateProfile.module.css';

const SectionFreeCreateProfile = props => {
  const { currentUser, handleGetStarted, isTeacher, currentState, content } = props;

  return (
    <div className={css.root}>
      <div className={css.contentContainer}>
        <div className={css.info}>
          <h2 className={css.title}>
            {content?.bottomTitle ?
              content.bottomTitle :
              <FormattedMessage id='SectionFreeCreateProfile.title' />
            }
          </h2>
          <h3 className={css.subtitle}>
            {content?.bottomDescription ?
              content.bottomDescription :
              <FormattedMessage id='SectionFreeCreateProfile.subtitle' />
            }
          </h3>

          {!currentUser && (
            <div className={css.emailContainer}>
              <Button className={css.button} onClick={handleGetStarted}>
                <FormattedMessage id='SectionHero.signUpJoinBtn' />
              </Button>
            </div>
          )}

          {currentUser && isTeacher && (
            <div className={css.createCourseContainer}>
              <NamedLink
                name='NewListingPage'
                className={css.button}
              >
                {currentState ? <FormattedMessage id='SectionHero.signUpJoinBtn' /> :
                  <FormattedMessage id='SectionHero.createCourseBtn' />}
              </NamedLink>
            </div>
          )}

        </div>
        <div className={css.imageContainer}>
          <img src={publishCourseImg} className={css.image} />
        </div>

      </div>
    </div>
  );
};

export default SectionFreeCreateProfile;
